/**
 * Created by Administrator on 2017/7/13.
 */
import * as actions from './actions.js';
import reducer from './reducer.js';
import view from './views/home.js';

export {actions, reducer, view};


// WEBPACK FOOTER //
// ./src/Pages/home/index.js